import type { IconSvgObject } from './types';

const ArrangeByLettersZAIcon: IconSvgObject = [
  ["path", { d: "M17.5 4V19.3056M15 17.5L17.5 20L20 17.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 3H9.4L4.6 10H10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M4 21L7 15L10 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ArrangeByLettersZAIcon;
